/**
 * No chrome at all — the screen paints its own full-page background.
 * Used by the install callback, which is a transient full-screen state.
 */
const BareLayout = ({ children }) => <div>{children}</div>;

export default BareLayout;
